import { ReactComponent as IconPlus } from "assets/svg/20-plus.svg";

import { UploadMoreWrapper } from "./style";

interface Props {
  onClick?: () => void;
}

const UploadMore = ({ onClick }: Props) => {
  return (
    <UploadMoreWrapper onClick={onClick}>
      <IconPlus />
    </UploadMoreWrapper>
  );
};

export default UploadMore;
